import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';

@Component({
  selector: 'app-vca-ressource-manager',
  templateUrl: './vca-ressource-manager.component.html',
  styleUrls: ['./vca-ressource-manager.component.scss']
})
export class VcaRessourceManagerComponent {
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) { }
  platformInfos:{[x: string]: any} = {origin: 'virtualcampus', key: 'vca', root: 'VIRTUALCAMPUS'};
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  filterData:any = [];
  modes:{ [x:string]: string|number }[] = [{id: 'vca_institution', value: 'Institution'}, {id: 'vca_structure', value: 'Structure'}, {id: 'vca_department', value: 'Department'}, {id: 'vca_module', value: 'Module'},  {id: 'vca_content', value: 'Content'}];
  pageId = 'vca-manage-ressource'
  manageKey:string = 'vca_content';
  

  ngOnInit(): void { }
  setProgress(data:any){

  }
  sendFilterData(data:any){
    this.inProgress.emit(true);
    this.manageKey = data.mode;
    this.filterData = data;
  }
}